module.exports = __webpack_public_path__ + "img/b924f29.png";